import PageConfig from '../templates/Page/PageConfig';

export const DASHBOARD: PageConfig = {
  name: 'My Dashboard',
  path: '/dashboard',
  redirectFrom: ['/'],
  exact: true,
  requiresAuthentication: true,
};

export const HOME: PageConfig = {
  name: 'Home',
  path: '/dashboard',
  redirectFrom: ['/'],
  exact: true,
  requiresAuthentication: true,
};

export const EARN: PageConfig = {
  name: 'Earn',
  path: '/surveys',
  exact: true,
  requiresAuthentication: true,
};

// cashout or rewards (both used in different places)
export const CASHOUT: PageConfig = {
  name: 'Cashout',
  path: '/cashouts',
  exact: true,
  requiresAuthentication: true,
};

export const LEAGUES: PageConfig = {
  name: 'Leagues',
  path: '/leagues',
  exact: true,
  requiresAuthentication: true,
};

// User can view other users' league profiles at /leagues/profile/:username
// but this page is for the logged in user to view their own league profile and edit their avatar
export const LEAGUE_PROFILE: PageConfig = {
  name: 'League Profile',
  path: '/league-profile',
  exact: false,
  requiresAuthentication: true,
};

export const AVATAR_BUILDER: PageConfig = {
  name: 'Avatar Builder',
  path: '/avatar-builder',
  exact: true,
  requiresAuthentication: true,
  fullPage: true,
};

export const HOW_LEAGUES_WORK: PageConfig = {
  name: 'How Leagues Work',
  path: '/how-leagues-work',
  exact: true,
  requiresAuthentication: true,
};

export const LOGIN: PageConfig = {
  name: 'Login',
  path: '/login',
  exact: true,
  requiresAuthentication: false,
};

export const REGISTRATION: PageConfig = {
  name: 'Registration',
  path: '/registration',
  exact: true,
  requiresAuthentication: false,
};

export const SIGN_UP: PageConfig = {
  name: 'Sign Up',
  path: '/sign-up',
  exact: true,
  requiresAuthentication: false,
};

export const WELCOME: PageConfig = {
  name: 'Landing Page',
  path: '/',
  exact: true,
  requiresAuthentication: false,
};

export const REWARDS: PageConfig = {
  name: 'Rewards',
  path: '/rewards',
  exact: true,
  requiresAuthentication: true,
};

export const PROFILE: PageConfig = {
  name: 'Profile',
  path: '/profile',
  exact: true,
  requiresAuthentication: true,
};

export const MORE: PageConfig = {
  name: 'More',
  path: '/more',
  exact: true,
  requiresAuthentication: true,
};

export const CHANGEPASSWORD: PageConfig = {
  name: 'Change Password',
  path: '/change-password',
  exact: true,
  requiresAuthentication: true,
};

export const MOBILETOPUPREWARDS: PageConfig = {
  name: 'Mobile Top Up',
  path: '/mobile-top-up-rewards',
  exact: true,
  requiresAuthentication: true,
};

export const PAYPALREWARDS: PageConfig = {
  name: 'PayPal Rewards',
  path: '/paypal-rewards',
  exact: true,
  requiresAuthentication: true,
};

export const EGIFTCARDREWARDS: PageConfig = {
  name: 'E-Gift Card Rewards',
  path: '/e-gift-card-rewards',
  exact: true,
  requiresAuthentication: true,
};

export const CASHBACK: PageConfig = {
  name: 'Cashback',
  description:
    'Earn cashback on great products and enjoy your wallet being a little bigger at the end of the month.',
  path: '/cashbacks',
  exact: false,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const DEALS: PageConfig = {
  name: 'Deals',
  description:
    'Find deals and money saving coupons on the biggest brands around or just let us show you ones you’ll like.',
  path: '/deals',
  exact: false,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const GAMING: PageConfig = {
  name: 'Gaming',
  description: 'Find gaming rewards and opportunities to earn while playing your favorite games.',
  path: '/gaming',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const REFER: PageConfig = {
  name: 'Refer',
  description: 'Invite your friends to join Qmee and earn rewards for each successful referral.',
  path: '/refer',
  exact: true,
  requiresAuthentication: true,
  shouldIndexPage: true,
};

export const BLOG: PageConfig = {
  name: 'Blog',
  description: 'Read our latest articles and updates on Qmee.',
  path: '/blog',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const PUBLIC_EARN: PageConfig = {
  name: 'Earn',
  path: '/earn-money-online',
  description: 'Earn money online with Qmee surveys',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

// Qmee Footer Pages

export const WHY_QMEE: PageConfig = {
  name: 'Why Qmee?',
  description: 'Check out these awesome reasons why you should choose our amazing community!',
  path: '/why-qmee',
  redirectFrom: ['/why-qmee'],
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const HOW_IT_WORKS: PageConfig = {
  name: 'How it works',
  description:
    'You can get rewarded for your opinions, your searches and your purchases. Share, shop & search to earn real cash.',
  path: '/how-it-works',
  redirectFrom: ['/how-it-works'],
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const SURVEY_TIPS: PageConfig = {
  name: 'Survey Tips',
  path: '/survey-tips',
  description: 'Survey Tips',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: false,
};

export const PRIVACY_PROMISE: PageConfig = {
  name: 'Privacy Promise',
  description: 'Privacy promise to users',
  path: '/privacy-promise',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const FAQ: PageConfig = {
  name: 'FAQ',
  description:
    'How do I earn cash? Shop, search & take surveys. Is the app free? Yes! What’s the minimum cashout amount? There is none!',
  path: '/faq',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const ABOUT: PageConfig = {
  name: 'About us',
  description:
    'Qmee is a digital rewards platform that allows users to earn cash rewards for their purchases & opinions, and gives brands a technology solution that gets faster, more accurate answers.',
  path: '/about',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const CONTACT_US: PageConfig = {
  name: 'Contact Us',
  description:
    'Got a question? Contact our dedicated & friendly customer support team - rated excellent for customer support.',
  path: '/contact',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const PARTNERS: PageConfig = {
  name: 'Partners',
  description: 'Here are some of our partners.',
  path: '/partners',
  requiresAuthentication: false,
  exact: true,
  shouldIndexPage: true,
};

export const SECURITY_PAGE: PageConfig = {
  name: 'Security Page',
  description: 'Report security problems with the app.',
  path: '/security',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const REQUEST_PASSWORD_RESET: PageConfig = {
  name: 'Reset Password',
  path: '/account/request-password-reset',
  // Component: React.lazy(() => import('./ResetPasswordRequest/ResetPasswordRequest')),
  exact: true,
  requiresAuthentication: false,
};

export const TERMS_AND_CONDITIONS: PageConfig = {
  name: 'Terms and Conditions',
  path: '/terms-and-conditions',
  exact: true,
  requiresAuthentication: false,
};

export const CASHOUT_GIFT_CARDS: PageConfig = {
  name: 'Gift Cards',
  path: '/cashouts/gift-cards',
  exact: true,
  requiresAuthentication: true,
};

export const CASHOUT_VENMO: PageConfig = {
  name: 'Venmo',
  path: '/cashouts/venmo',
  exact: true,
  requiresAuthentication: true,
};

export const CASHOUT_CHARITIES: PageConfig = {
  name: 'Charities',
  path: '/cashouts/charities',
  exact: true,
  requiresAuthentication: true,
};

export const PRIVACY_SETTINGS: PageConfig = {
  name: 'Privacy Settings',
  description: 'Manage your privacy settings',
  path: '/account/privacy-settings',
  exact: true,
  requiresAuthentication: true,
};

export const BLOG_POSTS: PageConfig = {
  name: 'Blog',
  path: '/blog',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const PRIVACY_NOTICE: PageConfig = {
  name: 'Privacy Notice',
  redirectFrom: ['/privacy_policy', '/privacy-policy'],
  description:
    'Qmee privacy notice which governs the collection, storage and use of personal data collected by us.',
  path: '/privacy-notice',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const COOKIE_NOTICE: PageConfig = {
  name: 'Cookie Notice',
  description:
    'Qmee cookie notice which explains why we use them and how you can better control their use.',
  path: '/cookie-notice',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const INSIGHTS: PageConfig = {
  name: 'Insights',
  description: 'Qmee insights which provide valuable information and tips.',
  path: '/cashouts/insights',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: true,
};

export const SURVEY_PROFILE: PageConfig = {
  name: 'Survey Profile',
  path: '/account/survey-profile',
  exact: true,
  requiresAuthentication: false,
  shouldIndexPage: false,
};

export const ACCOUNT_SETTINGS: PageConfig = {
  name: 'Account Settings',
  path: '/account/settings',
  exact: true,
  requiresAuthentication: true,
  shouldIndexPage: false,
};
